import ApiService from '../common/api.service'

class PaymentService extends ApiService {

  getWorldpayMeansOfPayments (isTokenisable) {
    return this.get(`/payment/means`, {
      params: {
        'psptype': 'WORLDPAY',
        'tokenisable': isTokenisable
      }
    }).then((res) => Promise.resolve(res.data))
  }

  validatePaymentWorldpay (orderRef, paymentStatus, paymentAmount, paymentCurrency, mac) {
    return this.get('/payment', {
      params: {
        'psptype': 'WORLDPAY',
        'reference': orderRef,
        'status': paymentStatus,
        'amount': paymentAmount,
        'currency': paymentCurrency
        // TODO 'mac': mac
      }
    }).then((res) => {
      return Promise.resolve(res.data)
    })
  }
}

export default PaymentService



// WEBPACK FOOTER //
// ./src/app/services/payment/payment.service.js